export default "__VITE_ASSET__DXWIHoxf__"